<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
			<img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"我知道了":"我知道了"}}
			</div>
            <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="客户名称">
							    <el-input v-model="kehumingcheng" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="特价状态">
							    <brselect style="width: 100%;" clearable category="tejiazhuangtai" :v="statusis"
							              v-model="statusis" @change="statuschangetype"></brselect>
							</el-form-item>
							<el-form-item label="创建时间" prop="sapCode" style="width: 50%;">
							    <el-date-picker
									v-model="formInline.cdatebegin"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
							    </el-date-picker>
							    <span class="w-time-to">至</span>
							    <el-date-picker
									v-model="formInline.cdateend"
									clearable
									type="date"
									value-format="yyyy-MM-dd" >
							    </el-date-picker>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="特价类型">
										<brselect style="width: 100%;" clearable category="category_tejia" :v="tejiacategory"
												  v-model="tejiacategory" @change="categorychangetype"></brselect>
									</el-form-item>
									<el-form-item label="　　特价版本号">
										<el-input v-model="tejiabanbenhao" placeholder="请输入"></el-input>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
							<el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="tiaozhuanxinzeng" v-auth="'xztj'">新增特价</el-button>
						</div>
					</div>
                </div>
            </div>
            <div class="h-row T-jia">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                        ref="multipleTable"
                        @selection-change="handleSelectionChange"
                        :data="tableData2"
                        :span-method="objectSpanMethod"
						border
                        stripe
						max-height="450"
                        >
                        <el-table-column
                            type="selection"
                            width="45"
                            label="全选"
							fixed
                            >
                        </el-table-column>
                        <el-table-column
                            type="index"
                            width="40"
							fixed
                            label="#">
                        </el-table-column>
                        <el-table-column
                                prop="specialId"
                                label="特价版本号"
                                :show-overflow-tooltip="true"
                                width="160">
								<template scope="scope">
									<div style="text-align: left;">
										{{scope.row.specialId}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                            prop="reporter"
                            label="客户名称"
							:show-overflow-tooltip="true"
                            min-width="180">
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.reporter}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                            prop="startdate"
                            label="开始时间"
							:show-overflow-tooltip="true"
                            width="100"
                            >
                        </el-table-column>
                        <el-table-column
                            prop="enddate"
                            label="截止时间"
							:show-overflow-tooltip="true"
                            width="100"
                            >
                        </el-table-column>
                        <el-table-column
                                prop="status"
                                label="特价状态"
                                width="90">
                            <template slot-scope="scope" >
                                <div v-if="scope.row.bohui==1">
                                    {{"驳回"}}
                                </div>
                                <div v-if="scope.row.status==0 && scope.row.bohui==0">
                                    {{"草稿"}}
                                </div>
                                <div v-if="scope.row.status!=0 && scope.row.bohui==0">
                                    {{scope.row.status | dictname('tejiazhuangtai')}}
                                </div>
                            </template>
                        </el-table-column>
						<el-table-column
								prop="projectName"
								label="项目名称"
								:show-overflow-tooltip="true"
								width="180"
						>
						</el-table-column>
                        <el-table-column
                                prop="category"
                                label="特价类型"
								:show-overflow-tooltip="true"
                                width="90"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.category|dictname('category_tejia')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="productLevel"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="120"
                        >
                            <template slot-scope="scope">
                                {{scope.row.productLevel.substr(0,3) | dictname('product_level')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="grade"
                            label="产品型号"
							:show-overflow-tooltip="true"
                            width="180"
                            >
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.grade}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="wuliaohao"
                                label="产品编码"
                                width="120"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="dingjia"
                                label="基准价"
                                width="110"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="proDiscPrice"
                                label="申请特价"
                                width="110"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="proDiscount"
                                label="折扣率"
                                width="90"
                        >
                        </el-table-column>

                        <el-table-column
                            prop="visitNum"
                            width="90"
                            label="剩余产品数量">
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.visitNum}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                            prop="progress"
                            label="申请数量"
							:show-overflow-tooltip="true"
                            width="90">
							<template scope="scope">
								<div style="text-align: right;">
									{{scope.row.progress}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="cucode"
                                label="创建人编码"
                                :show-overflow-tooltip="true"
                                width="110"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="visitTime"
                                label="创建时间"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="tejiashuoming"
                                label="特价立项说明"
                                :show-overflow-tooltip="true"
                                width="180"
                        >
						<template scope="scope">
							<div style="text-align: left;">
								{{scope.row.tejiashuoming}}
							</div>
						</template>
                        </el-table-column>
                        <el-table-column
                            label="操作"
                            fixed="right"
                            width="280"
                            >
                            <template slot-scope="scope">
								<div class="w-caozuo" style="text-align: left;">
									<el-button
									    v-if = "scope.row.tiaozhuan!=0"
									    type="text"
									    size="small"
									    class="h-tableLink h-btn" @click="xinchakantiaozhuan(scope.row)"
									    >
									    查看
									</el-button>
									<el-button
									    v-if = "scope.row.tiaozhuan==0 && scope.row.cucode == _user.usercode"
									    type="text"
									    size="small"
									    class="h-tableLink h-btn" @click="xinchakantiaozhuan(scope.row)">
									    修改
									</el-button>
									<el-button
									        v-if="scope.row.defl == 2 && scope.row.status != 1 && scope.row.status != 3 && scope.row.status != 4
												&& scope.row.visitNum ==scope.row.progress
                                                && scope.row.cucode == _user.usercode
                                                "
									        type="text"
									        size="small"
									        class="h-tableLink h-btn"
									        @click="deleteRow(scope.row)">
									    作废特价
									</el-button>
									<el-button
									    v-if = "scope.row.tiaozhuan!=0"
									    type="text"
									    size="small"
									    class="h-tableLink h-btn"
									    @click="chakanjindu(scope.row)">跟踪
									</el-button>
									<el-button
									        v-if = "canShowYlcs && scope.row.rversion!=null && scope.row.rversion!=''"
									        type="text"
									        size="small"
									        class="h-tableLink h-btn"
									        @click="chakancesuan(scope.row)">查看测算信息
									</el-button>

									<el-button
											v-if = "scope.row.status != 1 && scope.row.status != 3 && scope.row.status != 4 && (_user.usercode== '00593289' || adminFlag)"
											type="text"
											size="small"
											class="h-tableLink h-btn" @click="changeVisitNum(scope.row)">
										调整数量
									</el-button>

								</div>


                            </template>admin
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="outexcel">批量导出
                            </el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogFormVisible2" class="h-dialog2">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>特价审批</h1>
                        <p>Special Offer</p>
                    </div>
                </div>
            </div>
            <div class="h-formLine">
                <el-form :model="tejiashenpi" label-position="right" ref="formLabelAlign2" :inline="true"
                         class="demo-ruleForm h-formbLine h-dialogForm" style="padding-top:0.38rem">
                    <el-form-item label="申请特价产品总数" class="h-elformWrap-2" style="position:relative">
                        <el-input v-model="tejiashenpi.zongshu" placeholder="请输入(正整数)"/>
                    </el-form-item>
                    <el-form-item label="申请有效期截至" class="h-elformWrap-2" style="position:relative">
                        <el-col :span="11">
                            <el-date-picker type="date" value-format="yyyy-MM-dd" v-model="tejiashenpi.youxiaoqi"
                                placeholder="选择时间" style="width: 1.6rem"></el-date-picker>
                        </el-col>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="dialogFormVisible2 = false">取消</el-button>
                <el-button class="h-btn h-formBtn h-bgblueQ2" @click="xiugaishenqing">修改申请</el-button>
            </div>
        </el-dialog>
		<el-dialog :close-on-click-modal="false" :visible.sync="changeVisitNumFlag" class="h-dialog2">
			<div class="h-dialogImg">
				<div class="h-disTable">
					<div class="h-tableCell">
						<h1>特价可用数量调整</h1>
					</div>
				</div>
			</div>

			<!-- 列表表格 -->
			<el-table
					:data="tejiashenpiVisitList"
					border
					style="width:100%; margin-top:0.3rem;"
					size="mini"
			>
				<el-table-column prop="proCode" label="产品编码" align="center" />
				<el-table-column prop="avaiNumber" label="剩余数量" align="center" width="100" />
				<el-table-column prop="useNum" label="使用数量" align="center" width="110">
					<template slot-scope="scope">
						<el-input
								v-model="scope.row.useNum"
								placeholder="请输入正整数"
								@input="handleIntInput(scope.row)"
								@change="changeOfferNum(scope.row)"
						/>
					</template>
				</el-table-column>
				<el-table-column prop="avaiNumberNew" label="调整后剩余数量" align="center">
				</el-table-column>
				<el-table-column prop="gkSapCode" label="国科订单" align="center" width="210">
					<template slot-scope="scope">
						<el-input v-model="scope.row.gkSapCode" placeholder="请输入" />
					</template>
				</el-table-column>
			</el-table>
			<div slot="footer" class="dialog-footer">
				<el-button class="h-btn h-formBtn h-bgwhite" @click="changeVisitNumFlag = false">取消</el-button>
				<el-button class="h-btn h-formBtn h-bgblueQ2" @click="changeAvaiNumber">提交</el-button>
			</div>
		</el-dialog>
        <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    </div>
</template>
<script>
    import showxuanzeren from '../../../components/dialog/selectshdfcesuan'
    import shouwuliao from '../../../components/dialog/wxwl'
    import ss from '../../../api/SystemService'
    import uploaddown from '../../../utils/updownfile'
    export default {
        components:{
            showxuanzeren,
            shouwuliao
        },
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                tejiabanbenhao:'',
                canShowYlcs:true,
				adminFlag:false,
                tejiacategory:'',
                toshow:'pricenew',
                checked:true    ,
				showOrhide:false,
				status:1,
                shifoudailishang:false,
                instid:'',
                showhistory:false,
                xuanwuliao:false,
                xuanzeren:false,
                shiyongrenOptions:[],
                //选择人员
                xuanzerenyuan:[],
                //盈利测算跳转的项目号
                yinglicesuanpid:'',
                //首次加载flag
                shoucijiazai:true,
                //盈利测算跳转的物料号
                yinglicesuanmarcode:'',
                //是否必填
                shifoujiaoyan:true,
                //是否检索标志
                lishijiansuozancun:false,
                //上传的证明资料的type名
                zhengmingziliao:'zhengmingziliao',
                //保存文件类型名的数组
                nameArr:[],
                save:1,
                //证明资料
                zhengmingziliaolist:[],
                //上传资料的回传
                shangchuanziliao:[],
                //暂存提交标识
                zancuntijiao:'',
                //新增特价id
                xinzengtejiaid:'0',
                //审批
                tejiashenpi:{
                    shengyukeyong:'',
                    zongshu:'',
                    youxiaoqi:'',
                    specialId:'',
                },
				//审批
				tejiashenpiVisitList :[
					{
						id:'',
						avaiNumber:'',
						avaiNumberNew:'',
						gkSapCode:''
					},
				],
                xiangmuordingdan:'1',//1项目  2订单
                xinzengtejia:{
                    //选中物料
                    xuanzhongwuliao:'',
                    //选中人
                    xuanzhongren:'',
                    //使用人
                    shiyongren:'',
                    //特价方式选中值
                    tejiafangshi: '',
                    //产品型号选中值
                    chanpinxinghao: '',
                    //项目名称选中值
                    xiangmumingcheng: '',
                    jinezhekou:'',
                    chanpinshuliang:'',
                    bizhong:'',
                },
                rules: {
                    xiangmumingcheng: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                    ],
                    xuanzhongwuliao: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                    ],
                    chanpinshuliang: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                        { type: 'number', message: '必须是数字', trigger: 'blur'},
                    ],
                    tejiafangshi: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                    ],
                    jinezhekou: [
                        { required: true, message: '不能为空', trigger: 'blur' },

                    ],
                    xuanzhongren: [
                        { required: true, message: '不能为空', trigger: 'blur' },

                    ],
                    bizhong: [
                        { required: true, message: '不能为空', trigger: 'blur' },
                    ],

                },
                //项目信息集合
                proMainResult: [],
                //项目id:项目对应产品的物料信息集合
                mdmMaterialInfoCopyMap: {},
                //传参
                chuancan: {
                },
                //保存视图集合 list
                svList: [],
                //全部特价版本信息 list
                ofList: [],
                //全部特价的产品信息 list
                ofdtList: [],
                //特价产品信息id:该产品的产品基础信息 map
                marMap: {},
                //特价产品信息id:该产品的特价版本 map
                ofBydtMap: {},
                //客户编码code :客户信息 map
                bsMap: {},
                // //客户信息 list
                // bsList: [],
                //翻页入参
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total:0,
                },
                tejiafangshiOptions: [
                    {
                        value:'jine',
                        label:'金额',
                    },
                    {
                        value:'zhekou',
                        label:'折扣',
                    },
                ],
                //特价状态选中值
                statusis: '',

                //客户名称选中值
                kehumingcheng: '',
                // kehumingchengOptions: [],
                xiangmumingchengOptions: [],
                chanpinxinghaoOptions: [],
                //选择时间1
                timechangeone: ['',''],
                //选择时间2
                timechangetwo: '',
                input1: '',
                sele: '项目',
                formInline: {
                    customerName: '',
                    cdatebegin: null,
                    cdateend: null,
                    type: ''
                },
                multipleSelection: [],
                tableData2: [],
                dialogFormVisible: false,
                dialogFormVisible2: false,
                formLabelAlign2: {
                    type1: '',
                    type2: ''
                },
                list: ["项目", "订单"],


                //游标集
                spanArr:[],

                //游标定位
                position:'',
				changeVisitNumFlag:false,

            }
        },
        //加载页面默认执行
        created() {
			// 遮罩
			this.showzhezhao()
            if(this._user.usertype=='1'){
                this.shifoudailishang = true;
                this.canShowYlcs = false;
            }
            //销售经理也不能看
            if(this.$store.getters.hasRole("swyl_xiaoshoujl")){
                this.canShowYlcs = false;
            }
			//是否管理员权限
			this.adminFlag = this.$store.getters.hasRole('swyl_admin');
            //获取使用人
            this.huoquxuanzerenyuan();
            //首次加载
            // this.getSpByNumAtCo();
            this.query();
            this.createQueryParams();
        },
        //监听
        watch:{
            dialogFormVisible(val){
                //若关窗，就把资料清空
                if(val==false){
                    this.xinzengtejia.xuanzhongren = '';
                    this.xinzengtejia.xuanzhongwuliao = '';
                    this.xinzengtejia.chanpinxinghao = '';
                    this.xinzengtejia.jinezhekou = '';
                    this.xinzengtejia.chanpinshuliang = '';
                    console.log('aaa??',this.zhengmingziliaolist)
                    console.log('bbb?',this.shangchuanziliao)
                    this.zhengmingziliaolist = [];
                    this.shangchuanziliao = [];
                    this.zancuntijiao = '';
                    console.log(this.zancuntijiao,"看看暂存清了没");
                    console.log('aaa??',this.zhengmingziliaolist)
                    console.log('bbb?',this.shangchuanziliao)
                }
            },
        },
        mounted() {

        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},
            deleteRow(v) {
                this.$msg.confirm("作废后该特价将不可用, 是否作废该特价?", () => {
                    ss.specialController.deleteRow(v.specialId).then(rd => {
                        if (rd.f == true) {
                            this.$msg.msgs(rd.msg);
                            this.query();
                        } else {
                            this.$msg.msge(rd.msg);
                            this.query();
                        }
                    })
                })
            },

			// 限制只能输入正整数
			handleIntInput(row) {
				row.avaiNumber = row.avaiNumber.toString().replace(/\D/g, '')
			},

			showzhezhao(){
				ss.salesList.toshow(this.toshow).then(rd => {
					console.log(rd)
				    if(rd == false){
				        this.showOrhide = false;
				    }else{
				        this.showOrhide = true;
				    }
				})
			},
            //记录游标的方法
            getSpanArr() {

                //游标集，每个元素的下标对应当前页table的每一行的行号，每个元素的数字对应这一行条件相同的共重复了几行
                this.spanArr = [];

                //遍历当前表元素
                this.tableData2.forEach((item, index) => {

                    //当第一行时
                    if (index === 0) {

                        //默认先放第一行是1次
                        this.spanArr.push(1);

                        //记录当前重复行的位置
                        this.position = 0;

                    //其他行
                    } else {

                        //如果该行上的特价版本id与上一行上的特价版本id重复
                        if (this.tableData2[index].specialId === this.tableData2[index - 1].specialId) {

                            //从游标集中取到记录重复行的那行的重复数字，自增1(又重复一次)
                            this.spanArr[this.position] += 1;

                            //因为这次重复了，所以放入0记录作为这行实际上应该被合并掉
                            this.spanArr.push(0);

                        //若不重复
                        } else {

                            //继续向游标集放入一个1作为本行没有重复的独立一次记录
                            this.spanArr.push(1);

                            //记录重复行位置的游标移动到本行位置
                            this.position = index;

                        }
                    }
                })
            },


            //合并单元行方法
            objectSpanMethod({row, column, rowIndex, columnIndex}) {


                //需要合并单元行的是哪几列
                if (columnIndex==0 || column.label=="特价状态"||column.label=="创建人"||column.label=="创建人编码"||
                    column.label=="创建时间"||column.label=="特价版本号" ||column.label=="客户名称" ||
                    column.label=="开始时间" || column.label=="截止时间"|| column.label=="特价类型"
                    || column.label=="操作" || column.label == '盈利测算状态'
                ) {

                    //从游标集取到对应行下标位置的行重复记录数字，作为需要被合并多少行的rowspan数(该行跨了几行)
                    const _row = this.spanArr[rowIndex];

                    //该行跨了几列
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    }
                }

            },
            closeIt(){
                this.showOrhide = false;
                if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
                }else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
            },
            nextStep(i){
                if(this.status ==1){
                        this.status = 2;
                }else if(this.status ==2){
                    if(this.checked){
                       ss.salesList.toshow(this.toshow,this.checked).then(rd => {
                       	console.log(rd)
                       	this.showOrhide = false;
                       })
                    }else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}

                }

            },

            //查看测算
            chakancesuan(q){

			    console.log(q,'qqqq')

			    var path = '';

			    //内销项目工具
			    if(q.cesuanleixing==1||q.cesuanleixing==2){

                    path = '/xiangmu/enterfive';

                //外销项目
                }else if(q.cesuanleixing==3){

                    path = '/xiangmu/entersix';

                //外销工具
                }else if(q.cesuanleixing==4){

                    path = '/xiangmu/enterseven';

                //租赁
                }else if(q.cesuanleixing==5){

                    path = '/rateFormulaZulinshiti';

                }

			    var shiti = {
                    chakanshiti:q.rversion
                }

			    console.log(shiti,'shitishitishiti')

                //跳转查看
                // this.$router.push({path: path, query: shiti });
				//新页面查看
				let routeData = this.$router.resolve({
					path: path,
					query: shiti
				});
				window.open(routeData.href, '_blank');
            },


            //查看进度
            chakanjindu(q){
                console.log(q,'看看是啥')
                this.instid = q.instid;
                this.showhistory = true;
            },
            tanchuwuliao(){
                this.xuanwuliao=true;
            },
            tanchuxuanzeren(){
                this.xuanzeren=true;
                // dialogFormVisible
            },
            //选择使用人
            shiyongrenxuanze(val){
                console.log(val,'+++使用人')
                this.xuanzeren=false;
                this.xinzengtejia.xuanzhongren = val.username;
                this.xinzengtejia.shiyongren = val.usercode;
                //换项目
                this.anrenyuanxuanzexiangmu(val.usercode);
            },
            //切换产品型号的方法
            chanpinxinghaochangetype(val) {
                console.log(val,'+++物料')
                console.log(this.xinzengtejia.chanpinxinghao);
                 this.xinzengtejia.chanpinxinghao = val.matecode;
                 this.xinzengtejia.xuanzhongwuliao = val.matedes;
                 this.xuanwuliao = false;
            },
            //按人员选项目
            anrenyuanxuanzexiangmu(q){
                this.xiangmumingchengOptions = [];
                var id = {
                    id:q
                }
                ss.specialController.anrennaxiangmu(id).then(rd => {
                    console.log(rd.obj,'看看有啥')
                    //加载项目名称下拉选框
                    for(var ss in rd.obj){
                        var cus = {
                            value:rd.obj[ss].id,
                            label:rd.obj[ss].projectName,
                        }
                        this.xiangmumingchengOptions.push(cus);
                    }
                })
            },
            //获取选择人员
            huoquxuanzerenyuan(){
            },
            //前台转发接收加载的方法
            qiantaifanguolai(){
                //若有前页跳转的
                if(this.$router.history.current.query){
                    //带有物料号跳转的
                    if(this.$router.history.current.query.marcode){
                        //获取跳转物料号
                        this.yinglicesuanmarcode = this.$router.history.current.query.marcode;
                        //打开添加特价
                        this.addPrice();
                    }
                    //带有项目号跳转的
                    if(this.$router.history.current.query.proid){
                        //获取跳转的项目号
                        this.yinglicesuanpid = this.$router.history.current.query.proid;
                        //打开添加特价
                        this.addPrice();
                    }
                }else{

                    //取消首次加载flag
                    this.shoucijiazai = false;
                }
            },
            kankanj(val){
                console.log(val,'选哦了没')
            },
            handleSelectionChange(val) {
                console.log(val,'???????????')
                this.multipleSelection = val;
            },


            //跳转新增
            tiaozhuanxinzeng(){
              //订单关联漏斗 当前登录是否在 配置表中
              var item = localStorage.getItem("userId");
              ss.loudnew.isAgentOrderLoud(item).then(res=>{
                if (res.msg == '2'){
                  this.$router.push({ path: '/newprice2' });
                }else {
                  this.$router.push({ path: '/newprice' });
                }
              });
            },
			changeVisitNum(v){
				console.log(v)
				//查询列表
				ss.specialController.selectDetailList(v.specialId).then(rd => {
					console.log(rd)
					this.tejiashenpiVisitList = rd;
					this.changeVisitNumFlag = true;
				})
			},

            addPrice() {
                this.xinzengtejia.shiyongren = '',
                this.sele = '项目';
                this.xiangmuordingdan='1';
                console.log(this.zancuntijiao,"123445")
                if(this.zancuntijiao==''||this.zancuntijiao==null){
                    this.zancuntijiao = this.$util.getUuid();
                }
                this.dialogFormVisible = true;
                this.seleproNum();
            },
            seleType(item) {
                this.xinzengtejia.xuanzhongren = '';
                this.xinzengtejia.xuanzhongwuliao = '';
                this.xinzengtejia.chanpinshuliang = '';
                this.xinzengtejia.jinezhekou = '';
                this.sele = item;
                if(item=='订单'){
                    this.xiangmuordingdan='2';
                    this.shifoujiaoyan=false;
                    this.seleproNum();
                }else{
                    this.xiangmuordingdan='1';
                    this.shifoujiaoyan=true;
                    this.seleproNum();
                }
            },
            //去掉已上传附件的方法
            handleRemove(file, fileList) {
                console.log("删除了走这个?")
                console.log(file, fileList);
                console.log("要删除的那个文件的id",file.id)
                //把文件更新成删除
                this.delfile(file.id);
            },
            //文件更新为删除
            delfile(id){
                var id = {
                    id:id,
                }
                ss.specialController.updatedelbyid(id).then(rd => {
                    console.log("更新删除成功",rd.obj)
                });
            },
            handlePreview(file) {
                console.log(file);
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				});
            },
            //加载项目信息
            seleproNum(){
                this.xinzengtejia.xiangmumingcheng = '';
                this.xiangmumingchengOptions = [];
                this.xinzengtejia.chanpinxinghao = '';
                this.chanpinxinghaoOptions = [];
                this.xinzengtejia.tejiafangshi = '';
                this.xinzengtejia.shiyongren = '';
                this.xinzengtejia.bizhong = '';
                ss.specialController.seleproNum(this.xinzengtejia.xuanzhongren).then(rd => {
                    this.proMainResult = rd.proMainResult;
                    this.mdmMaterialInfoCopyMap = rd.mdmMaterialInfoCopyMap;
                    console.log(rd.mdmMaterialInfoCopyMap,'有没有？？')
                    //若是项目
                    if(this.xiangmuordingdan==1){
                        //加载项目名称下拉选框
                        for(var ss in rd.proMainResult){
                            var cus = {
                                value:rd.proMainResult[ss].id,
                                label:rd.proMainResult[ss].projectName,
                            }
                            this.xiangmumingchengOptions.push(cus);
                        }
                    }
                    //前台跳转的物料号
                    if(this.shoucijiazai&&this.$router.history.current.query&&this.$router.history.current.query.marcode){
                        //订单flag
                        this.xiangmuordingdan = 2;
                        //订单
                        this.sele = '订单';
                        //todo 盈利测算工具算完转过来的申请特价到底算是给谁的特价？？
                        // this.xinzengtejia.xuanzhongren = this.$router.history.current.query.yonghuming;
                        // this.xinzengtejia.shiyongren = this.$router.history.current.query.usercode;
                        this.xinzengtejia.xuanzhongwuliao = this.$router.history.current.query.wuliaoming;
                        this.xinzengtejia.chanpinxinghao = this.$router.history.current.query.marcode;
                        this.xinzengtejia.chanpinshuliang = parseInt(this.$router.history.current.query.xiaoliang);
                        this.xinzengtejia.jinezhekou = parseFloat(this.$router.history.current.query.danjia);
                        this.xiangmuordingdan = 2;
                        this.dialogFormVisible = true;
                        //取消首次加载flag
                        this.shoucijiazai = false;
                    }
                    //前台跳转的项目号
                    if(this.shoucijiazai&&this.shoucijiazai&&this.$router.history.current.query&&this.$router.history.current.query.proid){
                        this.xinzengtejia.xiangmumingcheng = this.$router.history.current.query.proid;
                        //订单flag
                        this.xiangmuordingdan = 1;
                        //订单
                        this.sele = '项目';
                        this.xinzengtejia.xiangmumingcheng = this.$router.history.current.query.proid;
                        this.xiangmuordingdan = 1;
                        this.dialogFormVisible = true;

                        //取消首次加载flag
                        this.shoucijiazai = false;
                    }
                })
            },
            //切换特价方式的方法
            // tejiafangshichangetype() {
            //     console.log(this.statusis);
            // },

            //切换特价类型的方法
            categorychangetype(val){
                console.log(val,'leixing');
            },

            //切换特价状态的方法
            statuschangetype() {
                console.log(this.statusis);
            },
            // //切换客户名称的方法
            // kehumingchengchangetype() {
            //     console.log(this.kehumingcheng);
            // },
            //切换项目名称的方法
            xiangmumingchengchangetype() {
                console.log(this.xinzengtejia.xiangmumingcheng);
                // this.changethechanpinxinghao();
            },
            //查询翻页
            query() {
                 var queryParams = this.createQueryParams();
                // this.q.enddate = this.timechangetwo;
                    console.log(this.q, "下面表格参数");
                console.log(queryParams, "下面表格参数queryParams");
                ss.specialController.tejiashitulistPage(queryParams).then(rd => {
                    console.log(this.q,'qq')
                    console.log(rd, "下面表格");
                    this.q.total = rd.total;
                    this.gettableels(rd.records);
                    console.log(rd.records, "下面表格数据");
                })
            },
            createQueryParams(){

			    console.log(this.statusis,'statusis')
                this.q.username = this.kehumingcheng;
                // this.q.usercode = this.kehumingcheng;
                this.q.status = this.statusis!='10'?this.statusis:null;

				if(this.statusis=='10'||this.statusis==10){
					this.q.bohui = 1;

				}else if(!this.statusis){
					this.q.status = this.statusis;
					this.q.bohui = null;
				}
				else{
					this.q.status = this.statusis;
					this.q.bohui = 0;
				}

                // this.q.startdate = this.timechangeone==null?null:this.timechangeone[0]==''||this.timechangeone[0]==null?'':this.$util.riQi3(this.timechangeone[0]);
                // this.q.enddate =  this.timechangeone==null?null:this.timechangeone[1]==''||this.timechangeone[1]==null?'':this.$util.riQi3(this.timechangeone[1]);
                this.q.startdate = this.formInline.cdatebegin;
                this.q.enddate =  this.formInline.cdateend;
                this.q.category = this.tejiacategory;
                this.q.specialId = (this.tejiabanbenhao==null||this.tejiabanbenhao=='')?null:this.tejiabanbenhao;
                this.q.agentType = 1;
                return this.q;
            },
            //检索
            handleFilter() {
                this.lishijiansuozancun = true;
                this.q.pageNo = 1;
                this.query();
            },
            //导表
            outexcel() {
                // var c = []
                // for(var d in this.multipleSelection){
                //     var kk = {
                //         specialId:this.multipleSelection[d].specialId
                //     }
                //     c.push(kk);
                // }
                var ids =  _.join(_.map(this.multipleSelection,"specialId"),",");
                var queryParams = this.createQueryParams()||{};
                var form = _.clone(queryParams);
                form.ids=ids;
                uploaddown.down('/api/swyl/v1/tejiashitulist/viewSpecialList/downloadExcelByNum',form,"post");
                // ss.specialController.downloadExcelByNum(c);
            },
            //加载配置项
            // getSpByNumAtCo(){
            //     ss.specialController.findotherlistconfig().then(rd => {
            //         console.log(rd,'???wwww???')
            //         this.ofList = rd.ofList;
            //         // this.bsList = rd.bsList;
            //         this.query();
            //     })
            // },
            //加载数据
            gettableels(vw){
                if(!this.lishijiansuozancun){
                    this.statusis = '';
                    this.kehumingcheng = '';
                    this.timechangeone = ['',''],
                    this.timechangetwo = '';
                    this.lishijiansuozancun = false;
                }
                this.tableData2=[];
                this.formInline.statusis = '';
                // this.kehumingchengOptions = [];
                //加载表
                for(var ui in vw) {
                    var table =  {
                        rversion: vw[ui].rversion||null,
                        cesuanleixing: vw[ui].cesuanleixing||null,
                        bohui: vw[ui].bohui,
                        cucode: vw[ui].cucode,
                        cuname: vw[ui].cuname,
                        reporter: vw[ui].username,
                        visitTime: vw[ui].checkdate,
                        startdate: vw[ui].startdate,
                        enddate: vw[ui].enddate,
                        productLevel: vw[ui].productLevel,
                        wuliaohao: vw[ui].proCode,
                        dingjia: vw[ui].dingjia,
                        proDiscPrice: vw[ui].proDiscPrice,
                        proDiscount: vw[ui].proDiscount,
                        grade: vw[ui].materialDescrition,
                        visitNum: vw[ui].avaiNumber=='null'?0:vw[ui].avaiNumber,
                        status: vw[ui].status||'',
                        /*progress: vw[ui].useing==''||vw[ui].useing==null?'0/0':vw[ui].useing,*/
                        progress:vw[ui].totalNumber=='null'?0:vw[ui].totalNumber,
                        specialId: vw[ui].specialId,
                        zongshu: vw[ui].useing==''||vw[ui].useing==null?0:vw[ui].useing.split('/')[1],
                        tiaozhuan: vw[ui].status||'',
                        instid:vw[ui].instid,
                        category:vw[ui].category,//特价类型   ---项目特价0；产品特价1
                        defl:vw[ui].pid?1:2,
                        rateFormulaRenewVer:vw[ui].rateFormulaRenewVer||{}, //测算版本实体
                        danjia:vw[ui].danjia,
                        yunfei:vw[ui].yunfei,
                        baofei:vw[ui].baofei,
                        yongjin:vw[ui].yongjin,
                        tejiashuoming:vw[ui].tejiashuoming,
						projectName:vw[ui].projectName,
                      isLoud:vw[ui].isLoud,
                      customerChannel:vw[ui].customerChannel,
                      toCompanyname:vw[ui].toCompanyname,
                        // tejialeixing:vw[ui].category==0?'项目特价':vw[ui].category==1?'产品特价':vw[ui].category==3?'特殊直扣':vw[ui].category==4?'台阶政策':'',
                    };
                    console.log("qqqqqqqqqqqqqq",table)
                    this.tableData2.push(table);
                }


                // //加载客户名称选框
                // for(var ss in this.bsList){
                //     var cus = {
                //         value:this.bsList[ss].userCode,
                //         label:this.bsList[ss].userName,
                //     }
                //     if(ss==0){
                //         var cuse = {
                //             value:'',
                //             label:'--请选择--',
                //         }
                //         this.kehumingchengOptions.push(cuse);
                //     }
                //     this.kehumingchengOptions.push(cus);
                // }



                //加载特价状态选框
                // for(var ss in this.ofList){
                //     var cus = {
                //         value:this.ofList[ss].status,
                //         label:this.ofList[ss].status==0?'保存':this.ofList[ss].status==1?'已提交':this.ofList[ss].status==2?'审核通过':this.ofList[ss].status==3?'使用中':this.ofList[ss].status==4?'使用完毕':this.ofList[ss].status==5?'已过期':''
                //     }
                //     var cuse = {
                //         value:'',
                //         label:'--请选择--',
                //     }
                //     var c = 0;
                // }
                this.save = 0;

                this.getSpanArr();

                //若首次加载
                if(this.shoucijiazai){
                    //去看看有没有前页跳转来的
                    this.qiantaifanguolai();
                }
            },
            //清空选项
            qingkong(){
                this.statusis = '';
                this.kehumingcheng = '';
                this.tejiacategory = '';
                this.timechangeone = ['',''],
                this.timechangetwo = '';
                this.formInline.cdatebegin = '';
                this.formInline.cdateend = '';
                this.tejiabanbenhao = '';
                this.query();
            },
			changeOfferNum(row){
				row.avaiNumberNew = Number(row.avaiNumber) - Number(row.useNum) || 0;
			},
            //执行添加特价
            // toadddet(status){
            //     console.log(status,'status')
            //     console.log(this.xinzengtejia.chanpinxinghao,'产品编号')
            //     var shangchuanziliaomingcheng = [];
            //     shangchuanziliaomingcheng.push(this.zhengmingziliao);
            //     console.log(this.xinzengtejia.xuanzhongwuliao,'产品编号2222')
            //     var specialOfferDetailList = [{
            //         pid: this.xinzengtejia.xiangmumingcheng,//项目ID
            //         proCode:this.xinzengtejia.chanpinxinghao,//产品编号
            //         proDiscPrice: this.xinzengtejia.tejiafangshi=='jine'?this.xinzengtejia.jinezhekou:'',//产品折扣价格
            //         proDiscount: this.xinzengtejia.tejiafangshi=='zhekou'?this.xinzengtejia.jinezhekou:'',//产品折扣
            //         status: status,//保存状态  0暂存  1提交
            //         tejiafangshi: this.xinzengtejia.tejiafangshi=='jine'?1:this.xinzengtejia.tejiafangshi=='zhekou'?2:'',//特价方式
            //         zancuntijiao: this.zancuntijiao,//暂存提交的特价版本id
            //         shangchuanziliaomingcheng: shangchuanziliaomingcheng,//上传资料名称
            //         totalNumber:this.xinzengtejia.chanpinshuliang,//申请数量
            //         avaiNumber:this.xinzengtejia.chanpinshuliang,//申请数量
            //         userCode:this.xinzengtejia.shiyongren,//使用人usercode
            //         bizhong:this.xinzengtejia.bizhong,//币种
            //     }];
            //     console.log(specialOfferDetailList,'参数aaaaa')
            //     ss.specialController.saveSpecialDet(specialOfferDetailList).then(rd => {
            //         this.$msg.msgs(rd.msg);
            //         //清空暂存提交id
            //         this.zancuntijiao='';
            //         //重新加载
            //         this.getSpByNumAtCo();
            //         //关窗
            //         this.dialogFormVisible = false;
            //     });
            // },
            //新增特价
            // addSpecialDet(status){
            //     let regx = /^\d+\.\d+$/;
            //     let regx_two = /^\-\d\.?\d*$/;
            //     let regx_fuhao = `/^\-`;
            //     const newNum_two = regx.test(this.xinzengtejia.chanpinshuliang);
            //     const newNum_three = regx_two.test(this.xinzengtejia.chanpinshuliang);
            //     console.log('啥玩意',newNum_two);
            //     if(newNum_two||newNum_three){
            //         this.$msg.msgs("请输入正整数")
            //     }else{
            //         this.$refs['xinzengtejia'].validate((valid) => {
            //             if (valid) {
            //                 this.toadddet(status);
            //             } else {
            //                 console.log('error submit!!');
            //                 return false;
            //             }
            //         });
            //     }
            // },
            //修改申请
            xiugaishenqing(){
                var viewSpecialList = {
                    totalNumber:this.tejiashenpi.zongshu,
                    enddate:this.tejiashenpi.youxiaoqi,
                    specialId:this.tejiashenpi.specialId,
                }
                console.log(viewSpecialList,'提交的参数')
                ss.specialController.xiugaishenqing(viewSpecialList).then(rd => {
                    //重新加载
                    this.query();
                    //关窗
                    this.dialogFormVisible2 = false;
                })
            },

			changeAvaiNumber(){
				console.log(this.tejiashenpiVisitList,'提交的参数')
				ss.specialController.updateAvaiNumberById(this.tejiashenpiVisitList).then(rd => {
					//重新加载
					this.query();
					//关窗
					this.changeVisitNumFlag = false;
				})
			},

            //新查看跳转
            xinchakantiaozhuan(q){
			        console.log(q,'row')
              //订单关联漏斗 当前登录是否在 配置表中
              if (q.isLoud != undefined && q.isLoud == "1"){
                this.$router.push({ path: '/newprice2' , query: {chakan: q.specialId}});
              }else {
                this.$router.push({ path: '/newprice' , query: {chakan: q.specialId}});
              }
            },



            //查看跳转
            // chakantiaozhuan(q){
            //     console.log(q.specialId,'qasdewd')
            //     console.log(q.tiaozhuan)
            //     //如果审批状态是通过之后的就跳转查看详情页，如果不是就跳转特价详情页
            //     var url = q.tiaozhuan!=null&&q.tiaozhuan!='0'&&q.tiaozhuan>=2?'/price/priceToDetail':'/price/priceDetail';
            //     if(q.tiaozhuan!=null&&q.tiaozhuan!='0'){//如果没有状态就不跳
            //         this.$router.push({ path: url , query: {id: q.specialId}});
            //     }
            //     //如果是保存状态0，则
            //     if(q.tiaozhuan=='0'){
            //         var id = {
            //             id:q.specialId,
            //         }
            //         ss.specialController.chakanzancun(id).then(rd => {
            //             this.nameArr = rd.nameArr;
            //             this.addPrice();
            //             this.xiangmuordingdan = rd.tejialeixing;
            //             this.sele = rd.tejialeixing==1?'项目':'订单';
            //             // this.changethechanpinxinghao();
            //             this.xinzengtejia.xiangmumingcheng = rd.pn;
            //             this.xinzengtejia.chanpinxinghao = rd.xh;
            //             this.xinzengtejia.tejiafangshi = rd.tejiafangshi==1?'jine':rd.tejiafangshi==2?'zhekou':'';
            //             this.xinzengtejia.jinezhekou = rd.zhekoujine;
            //             this.xiangmuordingdan = rd.tejialeixing;
            //             this.zancuntijiao  = q.specialId;
            //             this.xinzengtejia.chanpinshuliang = rd.chanpinshuliang;
            //             this.xinzengtejia.shiyongren = rd.userCode;
            //             this.xinzengtejia.xuanzhongren = rd.username;
            //             this.xinzengtejia.xuanzhongwuliao = rd.xh;
            //             this.xinzengtejia.bizhong = rd.bizhong;
            //         })
            //     }
            // },
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
         width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
		z-index: 999999;
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;

		}
		.steps{
			position: absolute;
			z-index: 1;

		}
		.step1{
			top: 0;
			left: 0;

		}
		.step2{
			top: 0;
			right: 0;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
			z-index: 2;
		}
	}
</style>
